<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              ref="rolename"
              type="text"
              name="name"
              label="نام نقش"
              rules="required"
              validation-container-class="col-lg-6"
              input-class="form-control"
              v-model="form.name"
            />
            <bita-input
              ref="rolefaname"
              type="text"
              name="faname"
              label="نام فارسی نقش"
              rules="required"
              validation-container-class="col-lg-6"
              input-class="form-control"
              v-model="form.fa_name"
            />
            <bita-multiselect
              ref="rolepermission"
              name="permissions"
              label="مجوز ها"
              rules="required"
              validation-container-class="col-lg-12"
              input-class="form-control"
              :data-source="allPermissions"
              data-text-field="name"
              data-value-field="id"
              v-model="form.permission_id"
            />
          </div>
        </div>
      </bita-form>
      <div
        slot="footer"
        class="mt-4 d-flex flex-column flex-md-row justify-content-between"
      >
        <div class="col-12 col-md-2 m-0 p-0 mb-2 " v-if="!propsData.id">
          <bita-bootbutton
            type="primary"
            title="ذخیره"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-4 m-0 p-0" v-if="propsData.id">
          <bita-bootbutton
            type="primary"
            title="بروزرسانی"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-1 m-0 p-0">
          <bita-bootbutton
            class="w-100 bg-transparent text-danger border-0"
            type="danger"
            title="بستن"
            data-dismiss="modal"
            @click.native="
              () => {
                $emit('change-status-modal');
              }
            "
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
        fa_name: "",
        permission_id: "",
      },
    },
    propsPermissions: {},
  },
  data() {
    return {
      colWidth: "col-lg-4",
      allPermissions: [],
      form: {},
    };
  },
  watch: {
    propsData: function(_data) {
      this.form = _data;
    },
    propsPermissions: function(_data) {
      this.allPermissions = _data;
    },
  },
  methods: {
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      let refs = ["rolename", "rolefaname", "rolepermission"];
      for (let ref of refs) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
      this.$refs.form.reset();
    },
  },
};
</script>
